import { useLazyQuery } from "@apollo/client";
import { useCallback, useMemo } from "react";

import { AI_INTEGRATION_PROVIDER_BEDROCK } from "../constants";
import { AVAILABLE_AI_MODELS } from "./gql";

type LoadModelsArgs = {
  provider: string | undefined;
  apiKey: string;
  baseURL: string;
  space: string | undefined;
};

const useAiIntegrationAvailableModels = () => {
  const [loadAvailableModels, { data, previousData, error, loading, called }] = useLazyQuery(
    AVAILABLE_AI_MODELS,
    { context: { suppressFlashError: true } }
  );

  const loadModels = useCallback(
    ({ provider, apiKey, baseURL, space }: LoadModelsArgs) => {
      if (!provider || provider === AI_INTEGRATION_PROVIDER_BEDROCK || apiKey === "") {
        return;
      }

      void loadAvailableModels({
        variables: {
          provider,
          apiKey,
          baseURL: baseURL || null,
          space: space || null,
          providerConfig: null,
          providerIntegrationId: null,
        },
      });
    },
    [loadAvailableModels]
  );

  const models = useMemo(
    () => data?.availableAIModels || previousData?.availableAIModels || [],
    [data, previousData]
  );

  return { models, error, loading, called, loadModels };
};

export default useAiIntegrationAvailableModels;
